module.exports = __webpack_public_path__ + "media/images/WFC_Award_Black_w_0-68cb4e650933e51e48ea4a295a74304e.svg";